export const statuses = {
  IN_PROGRESS: "In Progress",
  FINISHED: "Finished",
  QUIT: "Quit",
  CANCELED_TIMED_OUT: "Canceled(Timed Out)",
  CANCELED_BEFORE_TIME: "Canceled(Before Time)",
  CANCELED_NO_TIMER: "Canceled(No Timer)",
};
